<div class="content_wrap_section">
    <div class="wrap_header_sectons">
        <div class="top_header_overlay"></div>
        <h1>채용 정보</h1>
    </div>

    <div class="about_us_wrap">
        <div class="container">
            <div class="row">
                <div class="con-md-12">
                    <div class="about_us_right_contents padding_left_side work_with_us_contents">
                        <h3>이나고와 함께 한계에 도전하세요!</h3>
                        <p>이나고 개발팀은 최첨단 기술을 넘어 도전을 거부하지 않는 열정적인 20인으로 구성된 팀입니다. 자연어 처리 및 AI 기술을 통한 언어 수준 향상 측면에서 몇몇 진전을 이루었습니다. 그리고 여기에 안주하지 않고 도전을 주저하지 않는다면, <a href="https://www.crimsoni.ai/work-with-us.htm" target="_blank">지금 지원하세요!</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>